import { rest } from 'msw';
import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './allowList.json';

const allowListSettingInit = (req, res, ctx) => {
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const scenario = new URLSearchParams(search).get('scenario');
  // scenario=withData: 已申請含清單資料; scenario=withWM: 有WM密碼(中階驗證)
  const mockKey = ['withData', 'withWM'].includes(scenario) ? scenario : 'default';
  const responseData = MOCK_DATA['AllowListController/allowListSettingInit'].success[mockKey];
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const applyAllowListSetting = (req, res, ctx) => {
  const responseData = MOCK_DATA['AllowListController/applyAllowListSetting'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const cancelAllowListSetting = (req, res, ctx) => {
  const responseData = MOCK_DATA['AllowListController/cancelAllowListSetting'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const updateAllowListSetting = (req, res, ctx) => {
  const responseData = MOCK_DATA['AllowListController/updateAllowListSetting'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const allowListBlockReport = (req, res, ctx) => {
  const responseData = MOCK_DATA['AllowListController/allowListBlockReport'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('AllowListController/allowListSettingInit'),
    withScenario(withAuthCheck(allowListSettingInit))
  ),
  rest.post(
    getApiEndpoint('AllowListController/applyAllowListSetting'),
    withScenario(withAuthCheck(applyAllowListSetting))
  ),

  rest.post(
    getApiEndpoint('AllowListController/cancelAllowListSetting'),
    withScenario(withAuthCheck(cancelAllowListSetting))
  ),
  rest.post(
    getApiEndpoint('AllowListController/updateAllowListSetting'),
    withScenario(withAuthCheck(updateAllowListSetting))
  ),
  rest.post(
    getApiEndpoint('AllowListController/allowListBlockReport'),
    withScenario(withAuthCheck(allowListBlockReport))
  ),
];
